import { BaseUserToken } from '../../common';

export class SimpleOAuthToken extends BaseUserToken {
    constructor(public type: string, public payload: any) {
        super();
    }
}
